import { Button, Stack, Typography } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export const EnterTheDojo: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Stack
      direction="column"
      spacing={2}
      p={4}
      justifyContent="center"
      alignItems="center"
      width={400}
    >
      <Typography variant="h5">{t("screens.enterTheDojo.title")}</Typography>
      <Button
        component={Link}
        to="/labeling-tool"
        size="large"
        color="success"
        variant="contained"
      >
        {t("screens.enterTheDojo.startLabelingButton")}
      </Button>
    </Stack>
  );
};
